module.exports = __webpack_public_path__ + "static/img/index-box-01-img1.aff0530.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index-box-01-img1.jpg
// module id = fY0S
// module chunks = 0